import React from "react"
import EcosuiteComponent, { Loading, Error } from "@common/EcosuiteComponent"

export default class ActualVsPredictedConsumption extends EcosuiteComponent {
  renderContent() {
    if (this.isContentError(this.props.readings)) {
      return <Error error={this.props.readings.getError()} />
    }
    if (this.isContentError(this.props.predictedConsumption)) {
      return <Error error={this.props.predictedConsumption.getError()} />
    }
    if (
      this.isContentValid(this.props.readings) &&
      this.props.readings.consumption !== undefined &&
      this.isContentValid(this.props.predictedConsumption) &&
      this.props.predictedConsumption.predictedConsumption !== undefined
    ) {
      let diff = -(100 - (this.props.readings.consumption / this.props.predictedConsumption.predictedConsumption) * 100)
      let positive = diff >= 0
      return <div className={`sidebar-heading ${positive ? "negative" : "positive"}`}>{`${diff ? Math.round(diff === Infinity ? 0 : diff) : 0} %`}</div>
    } else {
      return <Loading />
    }
  }
}
